var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"threeJsCard",attrs:{"fluid":"","id":"threeJS"}},[(_vm.showButton)?_c('v-btn',{attrs:{"id":"startVideoButton","elevation":"0","large":""},on:{"click":_vm.startVideo}},[_vm._v("Iniciar")]):_vm._e(),_c('canvas',{ref:"canvas",attrs:{"height":"100vh","width":"100vw"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }